import { render, staticRenderFns } from "./PelletizingProductInfoList.vue?vue&type=template&id=58d193ac&"
import script from "./PelletizingProductInfoList.vue?vue&type=script&lang=js&"
export * from "./PelletizingProductInfoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports